import { checkAccessToPath } from 'frontend/common/access-helpers'
import { ResourceSectionType } from 'frontend/common/layout/enum/resource-section-type'
import { computed } from 'vue'

export function useDemandSection(eou) {
  function hasAccessTo(path) {
    return checkAccessToPath(eou.value, path)
  }

  const section = computed(() => {
    const result = {
      name: 'Demand',
      sectionType: ResourceSectionType.Demand,
      items: [
        {
          title: 'Transport Bookings',
          isDisabled: false,
          path: 'transport-bookings',
          icon: 'mi-outlined mi-commute',
        },
        {
          title: 'All demands',
          isDisabled: false,
          path: 'all-demands',
          icon: 'mi-outlined mi-all-inclusive',
        },
        {
          title: 'Shift Jobs',
          isDisabled: false,
          path: 'shift-jobs',
          icon: 'mi-outlined mi-work-history',
        },
        {
          title: 'Transfer Groups',
          isDisabled: false,
          path: 'transfer-groups',
          icon: 'mi-outlined mi-group-add',
        },
        {
          title: 'Shuttle transfers',
          isDisabled: false,
          path: 'shuttle-transfers',
          icon: 'mi-outlined mi-directions-car',
        },
      ],
    }
    result.items = result.items.filter(el => hasAccessTo(el.path))
    if (result.items.length) {
      return result
    } else {
      return {}
    }
  })

  return section
}
